export enum StatisticsFunc {
  Count = 'count',
  Empty = 'empty',
  Filled = 'filled',
  Unique = 'unique',
  Max = 'max',
  Min = 'min',
  Sum = 'sum',
  Average = 'average',
  Checked = 'checked',
  UnChecked = 'unChecked',
  PercentEmpty = 'percentEmpty',
  PercentFilled = 'percentFilled',
  PercentUnique = 'percentUnique',
  PercentChecked = 'percentChecked',
  PercentUnChecked = 'percentUnChecked',
  EarliestDate = 'earliestDate',
  LatestDate = 'latestDate',
  DateRangeOfDays = 'dateRangeOfDays',
  DateRangeOfMonths = 'dateRangeOfMonths',
  TotalAttachmentSize = 'totalAttachmentSize',
}

export enum NoneFunc {
  None = 'none',
}
